import { ProcessType, type TemplateParameterResource, type TemplateResourceBase } from "@octopusdeploy/octopus-server-client";
import { useOptionalProducerProcessTemplateContext } from "../ProcessTemplates/ProducerProcessTemplateContext";
import { useOptionalProducerProjectTemplateContext, ProducerProjectTemplateContext, buildProducerProjectTemplateContextProps } from "./ProducerProjectTemplateContext";
export type { ProducerProjectTemplateContextProps } from "./ProducerProjectTemplateContext";
export { ProducerProjectTemplateContext, buildProducerProjectTemplateContextProps };
export interface ProducerTemplateProcessContext {
    type: ProcessType.ProcessTemplate | ProcessType.ProjectTemplate;
    template: TemplateResourceBase;
    parameters: TemplateParameterResource[];
    localNames: string[];
    variables?: Array<{
        Name: string;
        Type: string;
    }>;
}
export interface WithProducerTemplateProcessContextInjectedProps {
    producerTemplateProcessContext?: ProducerTemplateProcessContext;
}
export const useOptionalProducerTemplateProcessContext = (): ProducerTemplateProcessContext | undefined => {
    const processTemplateContext = useOptionalProducerProcessTemplateContext();
    const projectTemplateContext = useOptionalProducerProjectTemplateContext();
    if (processTemplateContext?.processTemplate) {
        return {
            type: ProcessType.ProcessTemplate,
            template: processTemplateContext.processTemplate,
            parameters: processTemplateContext.processTemplate.Parameters,
            localNames: processTemplateContext.localNames,
        };
    }
    if (projectTemplateContext) {
        return {
            type: ProcessType.ProjectTemplate,
            template: projectTemplateContext.projectTemplate,
            parameters: projectTemplateContext.parameters,
            variables: projectTemplateContext.variables?.Variables,
            localNames: projectTemplateContext.localNames,
        };
    }
    return undefined;
};
export const useProducerTemplateProcessContext = (): ProducerTemplateProcessContext => {
    const maybeProducerTemplateProcessContext = useOptionalProducerTemplateProcessContext();
    if (maybeProducerTemplateProcessContext === undefined) {
        throw new Error("useProducerTemplateProcessContext can only be used in the context of a project or process template.");
    }
    return maybeProducerTemplateProcessContext;
};
